import { render, staticRenderFns } from "./comission.vue?vue&type=template&id=dfc2d6b0&"
import script from "./comission.vue?vue&type=script&lang=js&"
export * from "./comission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports